/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Faq_Leave_AInputs */

const en_platform_faq_leave_a = /** @type {(inputs: Platform_Faq_Leave_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your clients, plans and history are yours. Cancel whenever you like and nothing is held hostage.`)
};

const pl_platform_faq_leave_a = /** @type {(inputs: Platform_Faq_Leave_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoi podopieczni, plany i historia są Twoje. Zrezygnuj, kiedy chcesz, nic nie zostaje zatrzymane.`)
};

/**
* | output |
* | --- |
* | "Your clients, plans and history are yours. Cancel whenever you like and nothing is held hostage." |
*
* @param {Platform_Faq_Leave_AInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_faq_leave_a = /** @type {((inputs?: Platform_Faq_Leave_AInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Faq_Leave_AInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_faq_leave_a(inputs)
	return en_platform_faq_leave_a(inputs)
});